import React, { useState } from 'react';
import { FadeUp } from './ui/FadeUp';
import { articles, categories } from '../data/articles';
interface InsightsPageProps {
  onNavigate: (view: any) => void;
}
export function InsightsPage({
  onNavigate
}: InsightsPageProps) {
  const [activeCategory, setActiveCategory] = useState('All');
  const filteredArticles = activeCategory === 'All' ? articles : articles.filter(a => a.category === activeCategory);
  return <div className="pt-32 pb-28 bg-[#faf6ff] min-h-screen" data-id="element-212">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-213">
        <FadeUp className="mb-12" data-id="element-214">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-215">
            SparkHR Insights
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl leading-relaxed" data-id="element-216">
            Perspectives on People Operations, HR infrastructure, and the
            systems growing companies need to scale. We share practical insights
            on building teams, structuring HR operations, and avoiding the
            common mistakes that slow companies down.
          </p>
        </FadeUp>

        {/* Category Filter */}
        <FadeUp delay={0.1} className="mb-12" data-id="element-217">
          <div className="flex flex-wrap gap-2" data-id="element-218">
            {categories.map(cat => <button key={cat} onClick={() => setActiveCategory(cat)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${activeCategory === cat ? 'bg-gray-900 text-white' : 'bg-white text-gray-600 border border-[#eee] hover:text-gray-900 hover:border-gray-300'}`} data-id="element-219">
                {cat}
              </button>)}
          </div>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-220">
          {filteredArticles.map((article, index) => <FadeUp key={article.slug} delay={index * 0.06} data-id="element-221">
              <div onClick={() => onNavigate({
            article: article.slug
          })} className="bg-white rounded-xl border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)] p-8 h-full flex flex-col cursor-pointer hover:shadow-[0_10px_40px_rgba(0,0,0,0.08)] transition-all duration-300 group" data-id="element-222">
                <div className="flex items-center justify-between mb-4" data-id="element-223">
                  <span className="text-xs font-medium text-purple-500 bg-purple-50 px-2.5 py-1 rounded-full" data-id="element-224">
                    {article.category}
                  </span>
                  <span className="text-xs text-[#9CA3AF] font-medium" data-id="element-225">
                    {article.date}
                  </span>
                </div>
                <h2 className="text-xl font-bold text-gray-900 mb-4 group-hover:text-purple-600 transition-colors" data-id="element-226">
                  {article.title}
                </h2>
                <p className="text-gray-600 text-sm leading-relaxed mb-8 flex-grow" data-id="element-227">
                  {article.summary}
                </p>
                <div className="text-purple-500 font-medium text-sm flex items-center group-hover:text-purple-700 transition-colors mt-auto" data-id="element-228">
                  Read More{' '}
                  <span className="ml-1 group-hover:translate-x-1 transition-transform" data-id="element-229">
                    →
                  </span>
                </div>
              </div>
            </FadeUp>)}
        </div>
      </div>
    </div>;
}